// extracted by mini-css-extract-plugin
export default {"saveButton":"save-changes_saveButton__vX0vx"};